/**
 * @generated SignedSource<<610171f2ecff92626e7eaca44640b36c>>
 * @relayHash 7354786c74bc87b4af0be7aa1c508959
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cabf46c80d68570a7536cd273538fd1d7a98ce651705dc29413ac4754b769dbc

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useRegisterAdminAnnouncementBannerQuery$variables = Record<PropertyKey, never>;
export type useRegisterAdminAnnouncementBannerQuery$data = {
  readonly adminAnnouncementBanner: {
    readonly appearance: string;
    readonly content: string;
    readonly id: string;
    readonly isDismissible: boolean;
    readonly title: string | null | undefined;
    readonly updatedAt: string;
  } | null | undefined;
};
export type useRegisterAdminAnnouncementBannerQuery = {
  response: useRegisterAdminAnnouncementBannerQuery$data;
  variables: useRegisterAdminAnnouncementBannerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "ConfluenceAdminAnnouncementBanner",
    "kind": "LinkedField",
    "name": "adminAnnouncementBanner",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "isDismissible"
      },
      {
        "kind": "ScalarField",
        "name": "content"
      },
      {
        "kind": "ScalarField",
        "name": "appearance"
      },
      {
        "kind": "ScalarField",
        "name": "title"
      },
      {
        "kind": "ScalarField",
        "name": "updatedAt"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useRegisterAdminAnnouncementBannerQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useRegisterAdminAnnouncementBannerQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "7354786c74bc87b4af0be7aa1c508959",
    "id": "cabf46c80d68570a7536cd273538fd1d7a98ce651705dc29413ac4754b769dbc",
    "metadata": {},
    "name": "useRegisterAdminAnnouncementBannerQuery",
    "operationKind": "query",
    "text": "query useRegisterAdminAnnouncementBannerQuery{adminAnnouncementBanner{id,isDismissible,content,appearance,title,updatedAt}}"
  }
};
})();

(node as any).hash = "240e64f11995d52e66311a69dc8032ab";

export default node;
